type PlaceFn = (cloud: HTMLElement, object: HTMLElement) => void

const getObjectAnchor = (object: HTMLElement) => {
  const rect = object.getBoundingClientRect()
  const stage = document.querySelector('.playground__stage')?.getBoundingClientRect()
  const x = rect.left + (rect.width / 2)
  const visible = object.isConnected && (!stage || (
    x >= stage.left && x <= stage.right && rect.top >= stage.top && rect.top <= stage.bottom
  ))
  return { rect, x, visible }
}

// ustawia chmurkę nad obiektem; ukrywa ją, gdy obiekt wyjedzie poza obszar mapy
export const placeCloud: PlaceFn = (cloud, object) => {
  const { rect, x, visible } = getObjectAnchor(object)
  const rightDirection = rect.left > window.innerWidth / 2

  cloud.classList.toggle('--right', rightDirection)
  cloud.style.left = rightDirection ? '' : `${x}px`
  cloud.style.right = rightDirection ? `${window.innerWidth - x}px` : ''
  cloud.style.top = `${rect.top - 5}px`
  cloud.style.visibility = visible ? '' : 'hidden'
}

// ustawia znacznik wyśrodkowany nad obiektem
export const placeMarker: PlaceFn = (marker, object) => {
  const { rect, x, visible } = getObjectAnchor(object)
  marker.style.left = `${x}px`
  marker.style.top = `${rect.top - 5}px`
  marker.style.visibility = visible ? '' : 'hidden'
}

// callback ref: dopóki chmurka jest w DOM, podąża za obiektem (zoom, przesuwanie mapy, resize)
export const followObject = (object: HTMLElement, place: PlaceFn = placeCloud) => {
  let frame = 0
  let lastPosition = ''
  return (cloud: HTMLDivElement | null) => {
    cancelAnimationFrame(frame)
    if (!cloud) return

    const tick = () => {
      const rect = object.getBoundingClientRect()
      const position = `${rect.left}|${rect.top}|${rect.width}|${window.innerWidth}|${object.isConnected}`
      if (position !== lastPosition) {
        lastPosition = position
        place(cloud, object)
      }
      frame = requestAnimationFrame(tick)
    }
    tick()
  }
}
